module.exports = __webpack_public_path__ + "static/media/menu.57f252e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Pricing/PriceList/menu.svg
// module id = 727
// module chunks = 0